import React from "react";
import PropTypes from "prop-types";
import MessageRcs from "../rcs/Message";
import MessageText from "../rcs/MessageText";
import { MessageChat } from "../rcs/DevicePreview";

const MessageSimpleRcs = ({ step }) => {

  return (
    <div className="bg-white py-3 rounded-lg">
      <div className="px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-end gap-2 my-2">
            <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
              <span className="font-bold">{step}</span>
            </div>
          </div>
        </div>
        <div className="border rounded-lg">
          <div className="grid grid-cols-12">
            <div className="col-span-8">
              <MessageRcs />
            </div>
            <div className="col-span-4">
              <div className="text-md font-semibold py-3 mx-1">
                Previsualización
              </div>
              <MessageChat />
            </div>
          </div>
        </div>

        <div className="border rounded-lg mt-2">
          <MessageText />
        </div>
      </div>
    </div>
  );
};

MessageSimpleRcs.propTypes = {
  step: PropTypes.number,
};

export default MessageSimpleRcs;
